import React from "react";
import { CustomChip } from "../../../components/CustomChip";
import {
  ENROLMENT_STATUS_CHIP,
  EnrolmentStatus,
  SEQUENCE_STATUS_CHIP,
  SequenceStatus,
  STEP_RESULT_CHIP,
} from "../emailSequences.labels";

/** Status chip for a sequence (DRAFT / ACTIVE / INACTIVE). */
export const SequenceStatusChip: React.FC<{ status: string }> = ({
  status,
}) => {
  const cfg =
    SEQUENCE_STATUS_CHIP[status as SequenceStatus] ||
    SEQUENCE_STATUS_CHIP.DRAFT;
  return (
    <CustomChip
      size="small"
      color={cfg.color}
      content={cfg.label}
      sx={cfg.textColor ? { color: cfg.textColor } : undefined}
    />
  );
};

/** Status chip for an enrolment (ACTIVE / PAUSED / COMPLETED / STOPPED). */
export const EnrolmentStatusChip: React.FC<{ status: string }> = ({
  status,
}) => {
  const cfg =
    ENROLMENT_STATUS_CHIP[status as EnrolmentStatus] ||
    ENROLMENT_STATUS_CHIP.STOPPED;
  return (
    <CustomChip
      size="small"
      color={cfg.color}
      content={cfg.label}
      sx={cfg.textColor ? { color: cfg.textColor } : undefined}
    />
  );
};

/** Result chip for an executed step. */
export const StepResultChip: React.FC<{ result?: string | null }> = ({
  result,
}) => {
  if (!result) return <>{"\u2014"}</>;
  const cfg = STEP_RESULT_CHIP[result];
  if (!cfg) return <>{result}</>;
  return (
    <CustomChip
      size="small"
      color={cfg.color}
      content={cfg.label}
      sx={cfg.textColor ? { color: cfg.textColor } : undefined}
    />
  );
};
